var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_14360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22067 5.33203H11.78C11.9722 5.33201 12.1622 5.37356 12.3369 5.45383C12.5116 5.5341 12.6668 5.6512 12.792 5.7971C12.9172 5.943 13.0094 6.11424 13.0622 6.29909C13.115 6.48394 13.1272 6.67802 13.098 6.86803L12.2613 12.3027C12.1887 12.775 11.9494 13.2057 11.5867 13.5168C11.224 13.8279 10.7619 13.9988 10.284 13.9987H5.716C5.23827 13.9987 4.77632 13.8276 4.41376 13.5166C4.05119 13.2055 3.81195 12.7749 3.73934 12.3027L2.90267 6.86803C2.87345 6.67802 2.88566 6.48394 2.93847 6.29909C2.99128 6.11424 3.08344 5.943 3.20863 5.7971C3.33382 5.6512 3.48908 5.5341 3.66376 5.45383C3.83845 5.37356 4.02842 5.33201 4.22067 5.33203Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33333V4C6 3.46957 6.21071 2.96086 6.58579 2.58579C6.96086 2.21071 7.46957 2 8 2C8.53043 2 9.03914 2.21071 9.41421 2.58579C9.78929 2.96086 10 3.46957 10 4V7.33333",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_14360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon03);
export default __webpack_public_path__ + "static/media/dashboard-icon-03.9c53b586732f3ff250133a929b8968c2.svg";
export { ForwardRef as ReactComponent };